import { gql } from '@apollo/client';

import { ProductReviewsFragment } from './productDetailFragment.gql';

export const GET_STORE_CONFIG_DATA = gql`
  query getStoreConfigData {
    # eslint-disable-next-line @graphql-eslint/require-id-when-available
    storeConfig {
      store_code
      product_url_suffix
    }
  }
`;

export const GET_PRODUCT_DETAIL_QUERY = gql`
  query getProductDetailQuery($urlKey: String!) {
    products(filter: { url_key: { eq: $urlKey } }) {
      items {
        id
        uid
        __typename
        serial_name
        categories {
          uid
          name
          breadcrumbs {
            category_uid
            category_name
            category_level
          }
        }
        presale_product {
          status
          label
          note
        }
        show_attribute {
          label
          code
          value
          __typename
        }
        rating_summary
        review_count
        description {
          html
        }
        short_description {
          html
        }
        media_gallery_entries {
          uid
          label
          position
          disabled
          file
          url(type: "image", width: 1012, height: 1280)
        }
        features {
          type
          imgUrl
        }
        feature_icon {
          label
          image
        }
        video_url
        name
        product_size_chart {
          identifier
          title
          content
        }
        price {
          regularPrice {
            amount {
              currency
              value
            }
          }
        }
        prices {
          finalPrice {
            currency
            value
          }
          regularPrice {
            currency
            value
          }
        }
        price_range {
          maximum_price {
            final_price {
              currency
              value
            }
            discount {
              amount_off
            }
          }
          minimum_price {
            final_price {
              currency
              value
            }
            regular_price {
              currency
              value
            }
          }
        }
        sku
        small_image {
          url(type: "thumbnail", width: 1012, height: 1280)
        }
        stock_status
        url_key
        ... on CustomizableProductInterface {
          options {
            uid
            required
            title
            sort_order
            ... on CustomizableRadioOption {
              uid
              title
              option_id
              value {
                title
                option_type_id
                uid
              }
            }
          }
        }
        ... on ConfigurableProduct {
          configurable_options {
            attribute_code
            attribute_id
            uid
            label
            position
            product_id
            values {
              uid
              default_label
              label
              store_label
              use_default_value
              value_index
              swatch_data {
                ... on ImageSwatchData {
                  thumbnail
                }
                value
              }
            }
          }
          variants {
            attributes {
              code
              value_index
              uid
            }
            product {
              id
              uid
              media_gallery_entries {
                uid
                disabled
                file
                label
                position
                url(type: "image", width: 1012, height: 1280)
              }
              sku
              stock_status
              show_attribute {
                label
                code
                value
                __typename
              }
              price {
                regularPrice {
                  amount {
                    currency
                    value
                  }
                }
              }
              prices {
                finalPrice {
                  currency
                  value
                }
                regularPrice {
                  currency
                  value
                }
              }
              price_range {
                maximum_price {
                  final_price {
                    currency
                    value
                  }
                  regular_price {
                    currency
                    value
                  }
                  discount {
                    amount_off
                  }
                }
                minimum_price {
                  final_price {
                    currency
                    value
                  }
                  regular_price {
                    currency
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_RELATE_PRODUCT = gql`
  query getProductDetailForProductPage1($urlKey: String!) {
    products(filter: { url_key: { eq: $urlKey } }) {
      items {
        id
        uid
        related_products {
          id
          uid
          name
          serial_name
          sku
          price {
            regularPrice {
              amount {
                currency
                value
              }
            }
          }
          stock_status
          url_key
          price_range {
            maximum_price {
              final_price {
                currency
                value
              }
              discount {
                amount_off
              }
              regular_price {
                currency
                value
              }
            }
            minimum_price {
              final_price {
                currency
                value
              }
              regular_price {
                currency
                value
              }
              discount {
                amount_off
              }
            }
          }
          prices {
            finalPrice {
              currency
              value
            }
            regularPrice {
              currency
              value
            }
            ChildrenPrices {
              child_product_id
              sku
              finalPrice {
                currency
                value
              }
              regularPrice {
                currency
                value
              }
            }
          }
          rating_summary
          small_image {
            url(width: 1012, height: 1280)
          }
          hover_image(width: 1012, height: 1280)
        }
      }
    }
  }
`;

export const GET_PRODUCT_REVIEWS_QUERY = gql`
  query ProductReviewsQuery(
    $urlKey: String!
    $search: String
    $sort: ReviewsSortInput
    $review_current_page: Int!
    $pageSize: Int!
    $filter: ReviewFilterInput
    $ip: String!
  ) {
    products(filter: { url_key: { eq: $urlKey } }) {
      items {
        id
        ...ProductReviewsFragment
      }
    }
  }
  ${ProductReviewsFragment}
`;

export const GET_CUSTOMER_PHOTO_GALLERY = gql`
  query getCustomerPhotoGallery($product_id: String, $is_featured: String, $currentPage: Int!, $pageSize: Int!) {
    allReviews(
      filter: { product_id: { eq: $product_id }, is_featured: { eq: $is_featured } }
      currentPage: $currentPage
      pageSize: $pageSize
    ) {
      items {
        id
        nickname
        summary
        text
        created_at
        average_rating
        review_image {
          id
          url
          __typename
        }
        review_helpful {
          items {
            id
            is_help
            is_not_help
            is_owner
          }
          is_help_count
          is_not_help_count
        }
        video_url {
          url
        }
        __typename
      }
      __typename
    }
  }
`;

export default {
  getStoreConfigData: GET_STORE_CONFIG_DATA,
  getProductDetailQuery: GET_PRODUCT_DETAIL_QUERY,
  getProductReviewsQuery: GET_PRODUCT_REVIEWS_QUERY,
  getCustomerPhotoGallery: GET_CUSTOMER_PHOTO_GALLERY,
};
